import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import Html from 'helpers/Html';


function NotFound() {
	const {t} = useTranslation();

	useEffect(() => {
		Html.addClass('#root', 'h-100vh');
		return () => {
			Html.removeClass('#root', 'h-100vh');
		}
	})
	return (
		<div className="h-100">
			<div className="fixed-background"></div>

			<div className="container-fluid p-0 h-100 position-relative">
				<div className="row g-0 h-100">
					<div className="offset-0 col-12 d-none d-lg-flex offset-md-1 col-lg h-lg-100"></div>
					<div className="col-12 col-lg-auto h-100 pb-4 px-4 pt-0 p-lg-0">
						<div
							className="sw-lg-80 min-h-100 bg-foreground d-flex justify-content-center align-items-center shadow-deep py-5 full-page-content-right-border">
							<div className="sw-lg-60 px-5">
								<div className="sh-11 mb-3">
									<a href="/">
										<div className="logo-default"></div>
									</a>
								</div>
								<div className="mb-5">
									<h2 className="cta-1 mb-0 text-primary">{t('404.upTitle')}</h2>
									<h2 className="display-2 text-primary">{t('404.title')}</h2>
								</div>
								<div className="mb-5">
									<p className="h6">{t('404.description')}</p>
								</div>
								<div>
									<a href="/" className="btn btn-icon btn-icon-start btn-primary">
										<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
										     viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5"
										     strokeLinecap="round" strokeLinejoin="round"
										     className="cs-icon cs-icon-arrow-left">
											<path
												d="M9 17 2.35355 10.3536C2.15829 10.1583 2.15829 9.84171 2.35355 9.64645L9 3M18 10 3 10"></path>
										</svg>
										<span>{t('404.btn.back')}</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default NotFound;
